// ** Custom Components
import Avatar from '@components/avatar';

// ** Third Party Components
import classnames from 'classnames';
import { ReactSortable } from 'react-sortablejs';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { MoreVertical } from 'react-feather';

const Questions = (props) => {
  // ** Props
  const {
    questions,
    handleQuestionSidebar,
    setQuestions,
    setSelectedQuestion
  } = props;

  // ** Function to selectQuestion on click
  const handleQuestionClick = (obj) => {
    setSelectedQuestion(obj);
    handleQuestionSidebar();
  };

  return (
    <div className="todo-app-list">
      <PerfectScrollbar
        className="list-group todo-task-list-wrapper"
        options={{ wheelPropagation: false }}
        containerRef={(ref) => {
          if (ref) {
            ref._getBoundingClientRect = ref.getBoundingClientRect;

            ref.getBoundingClientRect = () => {
              const original = ref._getBoundingClientRect();

              return { ...original, height: Math.floor(original.height) };
            };
          }
        }}
      >
        {questions.length ? (
          <ReactSortable
            tag="ul"
            list={questions}
            handle=".drag-icon-custom"
            className="todo-task-list media-list"
            setList={setQuestions}
          >
            {questions.map((item, id) => {
              return (
                <li
                  key={id}
                  onClick={() => handleQuestionClick(item)}
                  className={classnames('todo-item', {
                    completed: false
                  })}
                >
                  <div
                    className="todo-title-wrapper drag-icon-custom"
                    style={{
                      userSelect: 'none'
                    }}
                  >
                    <div className="todo-title-area">
                      <MoreVertical className="drag-icon" />
                      <span className="todo-title">{item.question}</span>
                    </div>
                    <div className="todo-item-action mt-lg-0 mt-50">
                      <small className="text-nowrap text-muted me-1">
                        {item.type === 'open' ? 'Abierta' : 'Cerrada'}
                      </small>
                    </div>
                  </div>
                </li>
              );
            })}
          </ReactSortable>
        ) : (
          <div className="no-results show">
            <h5>No hay preguntas aun</h5>
          </div>
        )}
      </PerfectScrollbar>
    </div>
  );
};

export default Questions;
